
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { FormControl, Form, FormGroup, Button } from 'react-bootstrap'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'
import '../report.css'
// import { connect } from 'react-redux';

class ReportStockFixingCar extends Component {
  constructor(props) {
    super(props)
    const WHOLE_YEAR = momentHelper.getMonth()

    this.state = {
      loading:false,
      activePage:1,
      groupId:'requested_by',
      groupList:[{label:'เบิกโดย',value:'requested_by'},{label:'ซ่อมโดย',value:'fixed_by'},{label:'ทะเบียนรถ',value:'car_registration_no'},{label:'เบอร์รถ',value:'car_no'},{label:'ประเภทงานซ่อม',value:'work_for'},{label:'บริษัทประกัน',value:'insurer'}],
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),
      data:[],
      isRange:false,
      day:'00',
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      query:''
    }
    this.refTableId = 'ReportStockFixingCar-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month,this.state.day,this.state.groupId,this.state.query)
    }
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
}

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  } 

  loadData(year='',month='',day='',groupId='',query='') {
    this.setState({loading:true,isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year})
    ReportStore.loadReportStockFixingCar(year,month,day,groupId,query,(result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  loadDataRange(start='',end='',groupId='',query='') {
    ReportStore.loadReportStockFixingCarRange(start,end,groupId,query,(result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  renderRowData() {
    let {data} = this.state
    if (data.length>0) {
      return(
        data.map((item, index) => {
          return(
            <tr key={index}>
              <td className='text-center'>{item.work_date}</td>
              <td className='text-center'>{item.work_no}</td>
              <td className='text-center'>{item.customer_name}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.car_no}</td>
              <td className='text-center'>{item.work_for}</td>
              <td className='text-left'>{item.description}</td>
              <td className='text-center'>{item.quantity}</td>
              <td className='text-center'>{item.unit}</td>
              <td className='text-right'>{this.getNumberFormat(item.cost)}</td>
              <td className='text-right'>{this.getNumberFormat(item.price)}</td>
              <td className='text-center'>{item.fixed_by}</td>
              <td className='text-center'>{item.request_by}</td>
            </tr>
          )  
        })
      )
    } else {
      return(<tr><td colSpan={13}>{'ไม่พบข้อมูล'}</td></tr>)
    }  
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00') {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00') {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00') {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderTable() {
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-bordered-solid table-hover' style={{minWidth:'1800px'}}>
          <thead>
            <tr>
              <th style={{display:'none'}} colSpan={13}>รายงานซ่อมรถเบิกคลัง {this.getDate()}</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'110px'}}>วันที่ใบงาน</th>
              <th className='text-center' style={{width:'120px'}}>เลขที่ใบงาน</th>
              <th className='text-center' style={{width:'100px'}}>ลูกค้า</th>
              <th className='text-center' style={{width:'100px'}}>ทะเบียนรถ</th>
              <th className='text-center' style={{width:'80px'}}>เบอร์รถ</th>
              <th className='text-center' style={{width:'100px'}}>ประเภท</th>
              <th className='text-center' style={{width:'150px'}}>รายการ</th>
              <th className='text-center' style={{width:'90px'}}>จำนวน</th>
              <th className='text-center' style={{width:'90px'}}>หน่วย</th>
              <th className='text-center' style={{width:'100px'}}>ต้นทุน</th>
              <th className='text-center' style={{width:'100px'}}>ราคา</th>
              <th className='text-center' style={{width:'110px'}}>ซ่อมโดย</th>
              <th className='text-center' style={{width:'110px'}}>เบิกโดย</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={9}></th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('cost'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('price'))}</th>
              <th colSpan={2}></th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadData(this.state.year,this.state.month,val.value,this.state.groupId,this.state.query)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day
    })
    this.loadData(this.state.year,val.value,_day,this.state.groupId,this.state.query)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day:_day
    })
    this.loadData(val.value,this.state.month,_day,this.state.groupId,this.state.query)
  }

  onGroupChange(val) {
    this.setState({
      groupId: val.value
    })
    if (this.state.isRange) {
      const start = this.state.day+'/'+this.state.month+'/'+(this.state.year>0?this.state.year-543:this.state.year)
      const end = this.state.dayRange+'/'+this.state.monthRange+'/'+(this.state.yearRange>0?this.state.yearRange-543:this.state.yearRange)
      this.loadDataRange(start,end,this.state.groupId,this.state.query)
    } else  
      this.loadData(this.state.year,this.state.month,this.state.day,val.value,this.state.query)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานซ่อมรถเบิกคลัง.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportStockFixingCar&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&search_by='+this.state.groupId+'&query='+this.state.query+'&isRange=false'
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportStockFixingCar&start_date='+start+'&end_date='+end+'&search_by='+this.state.groupId+'&query='+this.state.query+'&isRange=true'
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,_day,this.state.groupId,this.state.query)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end,this.state.groupId,this.state.query)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end,this.state.groupId,this.state.query)
  }

  onQueryChange(e) {
    this.setState({query:e.target.value})
  }

  onQueryKeyPress(e) {
    if (e.charCode===13) {
      if (this.state.isRange) {
        const start = this.state.day+'/'+this.state.month+'/'+(this.state.year>0?this.state.year-543:this.state.year)
        const end = this.state.dayRange+'/'+this.state.monthRange+'/'+(this.state.yearRange>0?this.state.yearRange-543:this.state.yearRange)
        this.loadDataRange(start,end,this.state.groupId,this.state.query)
      } else
        this.loadData(this.state.year,this.state.month,this.state.day,this.state.groupId,this.state.query)
    }
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?this.state.dayRange:this.state.day)+'/'+this.state.month+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.dayRange+'/'+this.state.monthRange+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderToolbar() {
    return(
      <Form inline>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>  
        <div style={{ width: '150px', display: 'inline-block', marginLeft:'5px' }}>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.groupId}
            options={this.state.groupList}
            onChange={this.onGroupChange.bind(this)}
          />
        </div>
        {' '}
        <FormGroup style={{verticalAlign:'top'}}>
          <FormControl 
            placeholder='ค้นหา...'
            value={this.state.query} 
            onChange={this.onQueryChange.bind(this)} 
            onKeyPress={this.onQueryKeyPress.bind(this)} 
          />
        </FormGroup>
        {' '}
        <FormGroup style={{verticalAlign:'top',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  // renderPaging() {
  //   return (
  //     <div className="text-center pull-right">
  //       <Pagination
  //         prev
  //         next
  //         first
  //         last
  //         bsSize="medium"
  //         items={5}
  //         activePage={this.state.activePage}
  //         onSelect={this.onPageSelect.bind(this)} />
  //     </div>
  //   )
  // }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.day,this.state.groupId,this.state.query)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {/* this.renderPaging() */}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportStockFixingCar.defaultProps = {
  show: false,
  type: 'request'
}

export default ReportStockFixingCar;


// WEBPACK FOOTER //
// ./src/view/report/stock/ReportStockFixingCar.js